import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { logError } from '@utils/logger';

export class MapErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Map error:', error, info);
    logError('Map error:', { error, info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-[1000]">
          <div className="bg-[#2A2B2E] p-8 rounded-lg text-center max-w-lg mx-auto shadow-2xl border-2 border-red-500">
            <AlertTriangle className="w-16 h-16 text-red-500 mx-auto mb-6" />
            <h3 className="text-2xl font-bold text-red-500 mb-4">OversizeHUB Error</h3>
            <p className="text-red-400">
              {this.state.error?.message === 'Script error.' 
                ? 'Failed to load Google Maps. Please check your internet connection.' 
                : this.state.error?.message || 'Failed to load map'}
            </p>
            {process.env.NODE_ENV === 'development' && (
              <pre className="text-left text-xs text-red-300 bg-red-950/30 p-4 rounded-lg overflow-auto max-h-40 my-6 border border-red-500/30">
                {this.state.error?.stack}
              </pre>
            )}
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium shadow-lg shadow-red-500/20"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default MapErrorBoundary;